import styled from 'styled-components';

export const ErrorMessage = styled.p`
   color: red;
   border-radius: 3px;
   font-size: 1.1em;
   padding: 4px 8px;
   text-align: center;
   margin: 1rem auto;
   font-weight: 600;
   display: flex;
   flex-direction: row;
   justify-content: center;
   align-items: center;
`;

export default ErrorMessage;
